export default __webpack_public_path__ + "static/flatsidedringtube-845eed4d1b8103505c1ccdbcdfc8486e.png";